 const FIGHT_MODE = {
    SINGLE: 'SINGLE',
    GROUP: 'GROUP',
    TEST: 'TEST'
};

 export default FIGHT_MODE;


// WEBPACK FOOTER //
// ./src/pages/fight/FIGHT_MODE.ts